import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { finalize, forkJoin } from 'rxjs';
import { LanguageService, LoaderService } from '../../core';
import { UserService } from '../../services';
import { BaseComponent } from '../base';


/**
 * Component for language selection.
 */
@Component({
	selector: 'language-selection',
	templateUrl: './language-selection.component.html',
	imports: [
		FormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LanguageSelectionComponent extends BaseComponent implements OnInit {

	protected override readonly langSrv = inject(LanguageService);
	private readonly userSrv = inject(UserService);
	private readonly loaderSrv = inject(LoaderService);

	lang: string | null = null;
	langList: string[] = [];

	private _prevLang: string | null = null;


	ngOnInit(): void {
		forkJoin([this.userSrv.getLanguages(), this.userSrv.getUserLanguage()]).subscribe(([langs, lang]) => {
			this.langList = [...langs];
			this._prevLang = this.lang = lang ?? this.langSrv.DEFAULT_LANG;
		});
	}

	/**
 * Change user language.
 */
	changeLanguage(): void {
		if (this.lang) {
			this.loaderSrv.show();
			this.userSrv.changeLanguage(this.lang).pipe(
				finalize(() => this.loaderSrv.hide())
			).subscribe({
				next: () => {
					this._prevLang = this.lang;
					globalThis.location.reload();
				},
				error: () => this.lang = this._prevLang
			});
		}
	}

}
